import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";
import { getCommands } from "@/lib/commands";

/** Run a registered command by id (e.g. an EmptyState button that triggers `create`). */
export function useRunCommand() {
  const router = useRouter();
  return useCallback(
    (id: string) => {
      const c = getCommands().find((x) => x.id === id);
      c?.run({ navigate: (to) => void router.navigate({ to: to as never }) });
    },
    [router],
  );
}
